import { formatCalendarDatePendingChange } from 'utils/pendingChanges';

import { tableCellDateTypes } from '../DocumentExpirationDates.constants';

export const fieldsPendingChangeNormalizers = [
  ...tableCellDateTypes.map(fieldName => ({
    fieldName,
    normalize: ({ pendingChange }) => formatCalendarDatePendingChange(pendingChange),
  })),
];
